import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";

import { SiRoblox } from 'react-icons/si'
import { FaDiscord, FaGithub } from "react-icons/fa";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          <strong>🌙 REIYN</strong>
        </Navbar.Brand>
       <ul className="footer-icons">
                   <li className="social-icons">
                     <a
                       href="https://github.com/iamreiyn"
                       style={{ color: "white" }}
                       target="_blank" 
                       rel="noopener noreferrer"
                     >
                       <FaGithub />
                     </a>
                   </li>
                   <li className="social-icons">
                     <a
                       href="https://discord.com/users/262552056089280513"
                       style={{ color: "white" }}
                       target="_blank" 
                       rel="noopener noreferrer"
                     >
                       <FaDiscord />
                     </a>
                   </li>
                   <li className="social-icons">
                     <a
                       href="https://devforum.roblox.com/u/iamrenisal/summary"
                       style={{ color: "white" }}
                       target="_blank" 
                       rel="noopener noreferrer"
                     >
                       <SiRoblox />
                     </a>
                   </li>
                 </ul>
        
      </Container>
    </Navbar>
  );
}

export default NavBar;
